import React, { FC } from 'react'
import { Dots } from '@ynap/animations'
import BEMHelper from '@ynap/bem-helper'
import Overlay from '@ynap/overlay'

const bem = new BEMHelper('LoadingOverlay')

interface Props {
    messages: string[]
    className?: string
}

const LoadingOverlay: FC<Props> = ({ messages = [], className }) => (
    <Overlay>
        <div className={bem('wrapper', null, className)}>
            {messages.map((message, index) => (
                <div className={bem('message')} key={index}>
                    {message}
                </div>
            ))}
            <Dots className={bem('dots')} type={'secondary'} />
        </div>
    </Overlay>
)

export default LoadingOverlay
